import { render } from "./SelectDepartH5.vue?vue&type=template&id=0389341e&scoped=true"
import script from "./SelectDepartH5.vue?vue&type=script&lang=js"
export * from "./SelectDepartH5.vue?vue&type=script&lang=js"

import "./SelectDepartH5.vue?vue&type=style&index=0&id=0389341e&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0389341e"]])

export default __exports__